import React from 'react';
import { createUseStyles } from 'react-jss';
import Favourite from 'components/svg/Favourite';
import ButtonTypes from 'components/Button/Button.const';
import Button from 'components/Button';
import { styles } from './FavoriteButton.styles';

interface FavoriteButton {
  onFavoriteToggle: () => void;
  minimalButton?: boolean;
  isFavorite: boolean;
  'data-testid': string;
}
const useStyles = createUseStyles(styles, { name: 'FavoriteButton' });

const FavoriteButton = (props: FavoriteButton): JSX.Element => {
  const { onFavoriteToggle, minimalButton, isFavorite, 'data-testid': dataTestId } = props;
  const classes = useStyles();

  if (minimalButton) {
    return (
      <button data-testid={dataTestId} className={classes.minimalButton} onClick={onFavoriteToggle} type="button">
        <Favourite isActive={isFavorite} />
      </button>
    );
  }

  return (
    <Button
      icon={<Favourite isActive={isFavorite} />}
      text={isFavorite ? 'Toegevoegd' : 'Favorieten'}
      type={ButtonTypes.TERTIARY}
      onClick={onFavoriteToggle}
      data-testid={dataTestId}
    />
  );
};

export default FavoriteButton;
